import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
var ExtendzApiItemHostComponent = /** @class */ (function () {
    function ExtendzApiItemHostComponent(activatedRoute) {
        this.activatedRoute = activatedRoute;
    }
    ExtendzApiItemHostComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.all$ = this.activatedRoute.params.subscribe(function (param) {
            _this.id = param.id;
            _this.model = param.name;
        });
    }; // ngOnInit()
    ExtendzApiItemHostComponent.prototype.ngOnDestroy = function () {
        if (!this.all$)
            this.all$.unsubscribe();
    };
    ExtendzApiItemHostComponent = tslib_1.__decorate([
        Component({
            selector: 'ext-api-item-host',
            template: "<ext-api-item [model]=\"model\" [id]=\"id\"></ext-api-item>",
            styles: [" /*# sourceMappingURL=extendz-api-item-host.component.css.map */ "]
        }),
        tslib_1.__metadata("design:paramtypes", [ActivatedRoute])
    ], ExtendzApiItemHostComponent);
    return ExtendzApiItemHostComponent;
}());
export { ExtendzApiItemHostComponent };
//# sourceMappingURL=extendz-api-item-host.component.js.map